import type {
  Protocol,
  ProtocolType,
  ProtocolTypeItem,
} from '@/domain/Protocol';
import { api } from '@/lib/api';

export const createProtocolMutation = () => ({
  mutationFn: async ({
    data,
    image,
  }: {
    data: Partial<Protocol>;
    image?: File;
  }) => {
    const formData = new FormData();

    if (data.name) formData.append('name', data.name);
    if (data.type) formData.append('type', data.type);
    if (data.type_explanation)
      formData.append('type_explanation', data.type_explanation);

    if (data.protocol_types) {
      formData.append('protocol_types', JSON.stringify(data.protocol_types));
    }

    if (image) {
      formData.append('image', image);
    }

    return await api
      .post(`admin/protocols`, {
        body: formData,
        headers: {
          'Content-Type': undefined,
        },
      })
      .json<Protocol>();
  },
});

export const updateProtocolMutation = () => ({
  mutationFn: async ({
    id,
    data,
    image,
  }: {
    id: number;
    data: Partial<Protocol>;
    image?: File;
  }) => {
    const formData = new FormData();

    if (data.name) formData.append('name', data.name);
    if (data.type) formData.append('type', data.type);
    if (data.type_explanation)
      formData.append('type_explanation', data.type_explanation);

    if (image) {
      formData.append('image', image);
    }

    return await api
      .post(`admin/protocols/${id}`, {
        body: formData,
        headers: {
          'Content-Type': undefined,
        },
      })
      .json<Protocol>();
  },
});

export const deleteProtocolMutation = () => ({
  mutationFn: async (id: number) => {
    return await api.delete(`admin/protocols/${id}`).json<void>();
  },
});

export const createProtocolTypeMutation = () => ({
  mutationFn: async ({
    protocolId,
    data,
  }: {
    protocolId: number;
    data: Partial<ProtocolType>;
  }) => {
    return await api
      .post(`admin/protocols/${protocolId}/types`, { json: data })
      .json<ProtocolType>();
  },
});

export const updateProtocolTypeMutation = () => ({
  mutationFn: async ({
    protocolId,
    id,
    data,
  }: {
    protocolId: number;
    id: number;
    data: Partial<ProtocolType>;
  }) => {
    return await api
      .put(`admin/protocols/${protocolId}/types/${id}`, { json: data })
      .json<ProtocolType>();
  },
});

export const deleteProtocolTypeMutation = () => ({
  mutationFn: async ({
    protocolId,
    id,
  }: {
    protocolId: number;
    id: number;
  }) => {
    return await api
      .delete(`admin/protocols/${protocolId}/types/${id}`)
      .json<void>();
  },
});

export const createProtocolTypeItemMutation = () => ({
  mutationFn: async ({
    protocolId,
    typeId,
    data,
  }: {
    protocolId: number;
    typeId: number;
    data: Partial<ProtocolTypeItem>;
  }) => {
    return await api
      .post(`admin/protocols/${protocolId}/types/${typeId}/items`, {
        json: data,
      })
      .json<ProtocolTypeItem>();
  },
});

export const updateProtocolTypeItemMutation = () => ({
  mutationFn: async ({
    protocolId,
    typeId,
    id,
    data,
  }: {
    protocolId: number;
    typeId: number;
    id: number;
    data: Partial<ProtocolTypeItem>;
  }) => {
    return await api
      .put(`admin/protocols/${protocolId}/types/${typeId}/items/${id}`, {
        json: data,
      })
      .json<ProtocolTypeItem>();
  },
});

export const deleteProtocolTypeItemMutation = () => ({
  mutationFn: async ({
    protocolId,
    typeId,
    id,
  }: {
    protocolId: number;
    typeId: number;
    id: number;
  }) => {
    return await api
      .delete(`admin/protocols/${protocolId}/types/${typeId}/items/${id}`)
      .json<void>();
  },
});
